import appGlobalScript from '/tmp/scratch/ticom-feature-components_tzXsK/src/global/index.ts';
export const globalScripts = appGlobalScript;
